import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { extractUTMsFromURL } from 'utils/utmStorage';
import { setMarketingUTMs } from 'common/features/store/duck/utms/duck';
import { useRootSelector } from 'common/features/featuresReducer';
import { selectHasCapturedInitialUTMs } from 'common/features/store/duck/utms/selectors';

export const UTMCapture = () => {
    const dispatch = useDispatch();
    const hasCapturedInitialUTMs = useRootSelector(selectHasCapturedInitialUTMs);
    const hasAttemptedCapture = useRef(false);

    useEffect(() => {
        if (hasCapturedInitialUTMs) {
            if (!hasAttemptedCapture.current) {
                hasAttemptedCapture.current = true;
            }
            return;
        }

        if (hasAttemptedCapture.current) {
            return;
        }

        hasAttemptedCapture.current = true;

        try {
            const extractedUTMs = extractUTMsFromURL();
            const hasUTMs = Object.keys(extractedUTMs).length > 0;

            if (hasUTMs) {
                dispatch(setMarketingUTMs({ marketingUTMs: extractedUTMs }));
            } else {
                dispatch(setMarketingUTMs({ marketingUTMs: {} }));
            }
        } catch (error) {
            dispatch(setMarketingUTMs({ marketingUTMs: {} }));
        }
    }, [hasCapturedInitialUTMs, dispatch]);

    return null;
};
